import { api } from "../api";

export async function renderChats(el: HTMLElement): Promise<void> {
  el.innerHTML = `<h1>Chats</h1>
    <div class="toolbar">
      <select id="t"><option value="">все</option>
        <option value="private">DM</option>
        <option value="group">group</option>
        <option value="supergroup">supergroup</option>
      </select>
    </div>
    <div id="list">Загрузка…</div>`;
  const list = el.querySelector("#list")!;
  const sel = el.querySelector<HTMLSelectElement>("#t")!;
  async function load(): Promise<void> {
    const { total, chats } = await api.chats(0, 100, sel.value || undefined);
    list.innerHTML = `<p style="color:#7b8499">${total} чатов</p>
      <div class="table-wrap"><table>
        <thead><tr><th>ID</th><th>Тип</th><th>Title</th><th>Запросов</th>
          <th>Cost $</th><th>Лимит чата</th><th>Лимит юзера</th><th>Last active</th><th></th></tr></thead>
        <tbody>${chats.map(c => `
          <tr>
            <td>${c.id}</td><td>${c.type || '—'}</td>
            <td>${escape(c.title || '')}</td><td>${c.requests}</td>
            <td>${c.cost_total_usd}</td>
            <td><input type="number" data-l="per_chat" data-id="${c.id}" value="${c.limits.per_chat_daily ?? ''}" style="width:80px"/></td>
            <td><input type="number" data-l="per_user" data-id="${c.id}" value="${c.limits.per_user_daily ?? ''}" style="width:80px"/></td>
            <td>${(c.last_active || '').slice(0, 19).replace('T', ' ')}</td>
            <td><button data-save="${c.id}">Save</button></td>
          </tr>`).join("")}
        </tbody></table></div>`;
    list.querySelectorAll<HTMLButtonElement>("button[data-save]").forEach(b => {
      b.addEventListener("click", async () => {
        const id = Number(b.dataset.save);
        const pc = (list.querySelector<HTMLInputElement>(`input[data-l="per_chat"][data-id="${id}"]`)!).value;
        const pu = (list.querySelector<HTMLInputElement>(`input[data-l="per_user"][data-id="${id}"]`)!).value;
        try {
          await api.chatLimits(id, {
            per_chat_daily: pc ? Number(pc) : undefined,
            per_user_daily: pu ? Number(pu) : undefined,
          });
          b.textContent = "✓";
          setTimeout(() => (b.textContent = "Save"), 1500);
        } catch (e: any) { alert(e.message); }
      });
    });
  }
  sel.addEventListener("change", load);
  await load();
}

function escape(s: string): string {
  return s.replace(/[&<>"']/g, c => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]!));
}
